import type { GiaBanKhachHangData, GiaBanNhomKhachHangData } from '@/types/schemas';
import { khachHangSearchColumns, nhomColumns, QUERY_KEYS } from '@/constants';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface CustomerTabProps {
  mode: FormMode;
  khachHang: GiaBanKhachHangData | null;
  nhomKhachHang1: GiaBanNhomKhachHangData | null;
  nhomKhachHang2: GiaBanNhomKhachHangData | null;
  nhomKhachHang3: GiaBanNhomKhachHangData | null;
  setKhachHang: (khachHang: GiaBanKhachHangData) => void;
  setNhomKhachHang1: (nhomKhachHang: GiaBanNhomKhachHangData) => void;
  setNhomKhachHang2: (nhomKhachHang: GiaBanNhomKhachHangData) => void;
  setNhomKhachHang3: (nhomKhachHang: GiaBanNhomKhachHangData) => void;
}

const CustomerTab = ({
  mode,
  khachHang,
  nhomKhachHang1,
  nhomKhachHang2,
  nhomKhachHang3,
  setKhachHang,
  setNhomKhachHang1,
  setNhomKhachHang2,
  setNhomKhachHang3
}: CustomerTabProps) => {
  const isViewMode = mode === 'view';

  return (
    <div className='h-64 max-h-[calc(100vh-250px)] overflow-y-auto'>
      <div className='space-y-2 p-4' style={{ width: '800px', minWidth: '800px' }}>
        <div className='flex flex-col space-y-3'>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mt-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã khách hàng</Label>
            <SearchField<GiaBanKhachHangData>
              name='ma_kh'
              displayRelatedField={'customer_name'}
              columnDisplay={'customer_code'}
              searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
              searchColumns={khachHangSearchColumns}
              dialogTitle='Danh mục khách hàng'
              value={khachHang?.customer_code || ''}
              relatedFieldValue={khachHang?.customer_name || ''}
              onRowSelection={setKhachHang}
              disabled={isViewMode}
              className='w-100'
            />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mt-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nhóm khách hàng 1</Label>
            <SearchField<GiaBanNhomKhachHangData>
              columnDisplay={'ma_nhom'}
              searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC1`}
              searchColumns={nhomColumns}
              dialogTitle='Danh mục nhóm khách hàng 1'
              value={nhomKhachHang1?.ma_nhom || ''}
              relatedFieldValue={nhomKhachHang1?.ten_phan_nhom || ''}
              onRowSelection={setNhomKhachHang1}
              disabled={isViewMode}
              className='w-100'
            />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mt-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nhóm khách hàng 2</Label>
            <SearchField<GiaBanNhomKhachHangData>
              columnDisplay={'ma_nhom'}
              searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC2`}
              searchColumns={nhomColumns}
              dialogTitle='Danh mục nhóm khách hàng 2'
              value={nhomKhachHang2?.ma_nhom || ''}
              relatedFieldValue={nhomKhachHang2?.ten_phan_nhom || ''}
              onRowSelection={setNhomKhachHang2}
              disabled={isViewMode}
              className='w-100'
            />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mt-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nhóm khách hàng 3</Label>
            <SearchField<GiaBanNhomKhachHangData>
              columnDisplay={'ma_nhom'}
              searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC3`}
              searchColumns={nhomColumns}
              dialogTitle='Danh mục nhóm khách hàng 3'
              value={nhomKhachHang3?.ma_nhom || ''}
              relatedFieldValue={nhomKhachHang3?.ten_phan_nhom || ''}
              onRowSelection={setNhomKhachHang3}
              disabled={isViewMode}
              className='w-100'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerTab;
